const TOP_RESULTS_TYPE = {
    TOP100: '100',
    TOP200: '200',
    TOP500: '500',
    TOP900: '900',
};

export default TOP_RESULTS_TYPE;
